import { CertificateRevocationStatus } from '../../api'
import { getAllEnumOptions } from '../enum'

export const getAllCertificateRevocationStatuses = () =>
  getAllEnumOptions(CertificateRevocationStatus)

export const getCertificateRevocationStatusLabel = (
  key?: CertificateRevocationStatus,
) => {
  if (key === null || typeof key === 'undefined') return ''

  return CertificateRevocationStatus[key]
}
